class Config {
    private static instance: Config;
    public ReaderlyApiUrl: string = "";
    public TelegramLoginClientId: string = "";
    public GoogleLoginClientId: string = "";
  
    private constructor() {}
  
    public static getInstance(): Config {
      if (!Config.instance) {
        Config.instance = new Config();
        Config.instance.init()
      }
      return Config.instance;
    }
  
    public init() {
      this.ReaderlyApiUrl =
        process.env.REACT_APP_API_BASE_URL ||
        process.env.REACT_APP_READERLY_API_URL ||
        "/api";
      this.TelegramLoginClientId = process.env.REACT_APP_TELEGRAM_CLIENT_ID || "";
      this.GoogleLoginClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
    }
  }
  
  export const AppConfig = Config.getInstance();
